import { render, staticRenderFns } from "./RecordingBlock.vue?vue&type=template&id=119f1104&"
import script from "./RecordingBlock.vue?vue&type=script&lang=js&"
export * from "./RecordingBlock.vue?vue&type=script&lang=js&"
import style0 from "./RecordingBlock.vue?vue&type=style&index=0&id=119f1104&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports